import { render, staticRenderFns } from "./SelectedTicket.vue?vue&type=template&id=14fa4469&scoped=true"
import script from "./SelectedTicket.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedTicket.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedTicket.vue?vue&type=style&index=0&id=14fa4469&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa4469",
  null
  
)

export default component.exports